/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { ACCESSIBILITY_FORM_NODE_TITLE } from "constants/enums";

const getSelectedValuesText = (indices, exportValues) => {
  let stringToBeRead = `${indices.length} item${indices.length > 1 ? "s" : ""} selected`;

  indices.forEach(selectedIndex => (stringToBeRead += `, ${exportValues[selectedIndex]} selected`));
  return stringToBeRead;
};

export const AccessibleListBoxNode = ({ annotInfo: { tooltip, name, enumNames, currentValueIndices }, style }) => (
  <p style={style}>
    {`${tooltip || name}, ${ACCESSIBILITY_FORM_NODE_TITLE.READONLY} ${ACCESSIBILITY_FORM_NODE_TITLE.LISTBOX}, ${
      currentValueIndices.length
        ? getSelectedValuesText(currentValueIndices, enumNames)
        : ACCESSIBILITY_FORM_NODE_TITLE.EMPTY_VALUE
    }`}
  </p>
);
